import ToggleButton from 'components/common/ToggleButton';
import AddMeals from 'components/icons/illustrative/AddMeals';
import Apple from 'components/icons/illustrative/Apple';
import Avocado from 'components/icons/illustrative/Avocado';
import Beans from 'components/icons/illustrative/Beans';
import Bread from 'components/icons/illustrative/Bread';
import Dumbbell from 'components/icons/illustrative/Dumbbell';
import Fish from 'components/icons/illustrative/Fish';
import Leaf from 'components/icons/illustrative/Leaf';
import Olive from 'components/icons/illustrative/Olive';
import Scale from 'components/icons/illustrative/Scale';
import WeightWatchers from 'components/icons/illustrative/WeightWatchers';
import Wheat from 'components/icons/illustrative/Wheat';
import FunnelHeader from 'components/signUpFunnel/shared/FunnelHeader';
import {
  GLUTEN_SMART,
  CALORIE_CONSCIOUS,
  MEDITERRANEAN,
  CARB_CONSCIOUS,
  EAT_ANYTHING,
  KETO_FRIENDLY,
  PESCATARIAN,
  HIGH_PROTEIN,
  GLP_SMART,
  VEGETARIAN,
  FIBER_RICH,
  WEIGHT_WATCHERS,
} from 'lib/constants';

const IconMap = {
  [CALORIE_CONSCIOUS]: Apple,
  [CARB_CONSCIOUS]: Bread,
  [FIBER_RICH]: Beans,
  [GLP_SMART]: Scale,
  [GLUTEN_SMART]: Wheat,
  [EAT_ANYTHING]: AddMeals,
  [KETO_FRIENDLY]: Avocado,
  [MEDITERRANEAN]: Olive,
  [PESCATARIAN]: Fish,
  [HIGH_PROTEIN]: Dumbbell,
  [VEGETARIAN]: Leaf,
  [WEIGHT_WATCHERS]: WeightWatchers,
};

const DietaryPreferencesForm = ({
  header = '',
  subheader = '',
  containerClassName,
  preferences,
  handlePreferencesClick,
}) => {
  return (
    <>
      <div className={containerClassName}>
        <FunnelHeader title={header} subtitle={subheader} containerClassName="mb-6" />
        <div className="grid w-full grid-cols-1 gap-x-1.5 gap-y-2 bp1:grid-cols-2">
          {preferences?.dietaryPreferences.map(preference => {
            const IconComponent = IconMap[preference.friendlyName];
            return (
              <ToggleButton
                id={preference.id}
                className="relative flex w-full items-center justify-between rounded px-3"
                name={preference.friendlyName}
                selected={preference.selected}
                handleClick={() => handlePreferencesClick(preference)}
                type="refreshToggle"
                role="checkbox"
                aria-checked={preference.selected}
                aria-label={preference.friendlyName}
                key={`column-${preference.id}`}
              >
                {preference.friendlyName === GLUTEN_SMART
                  ? `${preference.friendlyName}*`
                  : preference.friendlyName}
                {IconComponent && <IconComponent className="ml-3 h-8 w-8" />}
              </ToggleButton>
            );
          })}
        </div>
      </div>
    </>
  );
};

DietaryPreferencesForm.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  containerClassName: PropTypes.string,
  preferences: PropTypes.object,
  handlePreferencesClick: PropTypes.func,
};

export default DietaryPreferencesForm;
